import makeStyles from '@mui/styles/makeStyles';

export const HomeStyle = makeStyles((theme) => ({
	page: {},
	container: {
		position: "relative",
		zIndex: 1,
		paddingTop: theme.spacing(3),
		[theme.breakpoints.down('sm')]: {
			paddingTop: theme.spacing(2),
			paddingLeft: theme.spacing(1.5),
			paddingRight: theme.spacing(1.5),
		},
	},
	hero: {
		display: "grid",
		gridTemplateColumns: "minmax(0, 1.3fr) minmax(320px, 0.7fr)",
		gap: theme.spacing(2),
		alignItems: "stretch",
		marginBottom: theme.spacing(2),
		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: "1fr",
		},
	},
	actionsPageHero: {
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		marginBottom: theme.spacing(2),
		padding: theme.spacing(3),
		border: "1px solid var(--atl-border)",
		borderRadius: 24,
		color: "#fff",
		background:
			"linear-gradient(135deg, color-mix(in srgb, var(--atl-blue) 88%, #000 0%) 0%, color-mix(in srgb, var(--atl-teal) 84%, #000 0%) 100%)",
		boxShadow: "var(--atl-shadow-strong)",
		overflow: "hidden",
		position: "relative",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			background:
				"radial-gradient(circle at 86% 18%, rgba(255,255,255,0.22), transparent 0 170px), linear-gradient(180deg, rgba(255,255,255,0.14), rgba(255,255,255,0))",
			pointerEvents: "none",
		},
		"& > *": {
			position: "relative",
			zIndex: 1,
		},
		[theme.breakpoints.down('sm')]: {
			alignItems: "stretch",
			flexDirection: "column",
			padding: theme.spacing(2.25),
		},
	},
	actionsPageTitle: {
		maxWidth: 780,
		color: "#fff",
		fontSize: 38,
		fontWeight: 900,
		lineHeight: 1.05,
		[theme.breakpoints.down('sm')]: {
			fontSize: 30,
		},
	},
	actionsPageSubtitle: {
		maxWidth: 680,
		marginTop: theme.spacing(1.25),
		color: "rgba(255,255,255,0.8)",
		fontSize: 15,
		fontWeight: 650,
		lineHeight: 1.45,
	},
	actionsPageStats: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(100px, 1fr))",
		gap: theme.spacing(1),
		minWidth: 250,
		[theme.breakpoints.down('sm')]: {
			minWidth: 0,
		},
	},
	actionsPageStat: {
		padding: theme.spacing(1.25),
		border: "1px solid rgba(255,255,255,0.24)",
		borderRadius: 18,
		background: "rgba(255,255,255,0.12)",
		boxShadow: "inset 0 1px 0 rgba(255,255,255,0.18)",
		"& $metricLabel": {
			color: "rgba(255,255,255,0.72)",
		},
		"& $metricValue": {
			color: "#fff",
		},
	},
	heroMain: {
		position: "relative",
		overflow: "hidden",
		minHeight: 220,
		padding: theme.spacing(3),
		border: "1px solid var(--atl-border)",
		borderRadius: 24,
		background:
			"linear-gradient(135deg, color-mix(in srgb, var(--atl-blue) 88%, #000 0%) 0%, color-mix(in srgb, var(--atl-teal) 84%, #000 0%) 100%)",
		boxShadow: "var(--atl-shadow-strong)",
		color: "#fff",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			background:
				"radial-gradient(circle at 78% 20%, rgba(255,255,255,0.22), transparent 0 170px), linear-gradient(180deg, rgba(255,255,255,0.16), rgba(255,255,255,0))",
			pointerEvents: "none",
		},
	},
	heroContent: {
		position: "relative",
		zIndex: 1,
		maxWidth: 760,
	},
	eyebrow: {
		marginBottom: theme.spacing(1),
		fontSize: 12,
		fontWeight: 900,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		opacity: 0.82,
	},
	heroTitle: {
		maxWidth: 780,
		fontSize: 40,
		fontWeight: 900,
		lineHeight: 1.05,
		color: "#fff",
		[theme.breakpoints.down('sm')]: {
			fontSize: 30,
		},
	},
	heroSubtitle: {
		maxWidth: 680,
		marginTop: theme.spacing(1.5),
		color: "rgba(255,255,255,0.78)",
		fontSize: 16,
		fontWeight: 650,
		lineHeight: 1.5,
	},
	heroActions: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(1),
		marginTop: theme.spacing(3),
	},
	heroButton: {
		color: "var(--atl-blue)",
		background: "rgba(255,255,255,0.9)",
		"&:hover": {
			background: "#fff",
		},
	},
	heroButtonGhost: {
		color: "#fff",
		borderColor: "rgba(255,255,255,0.36)",
		background: "rgba(255,255,255,0.1)",
		"&:hover": {
			borderColor: "rgba(255,255,255,0.58)",
			background: "rgba(255,255,255,0.18)",
		},
	},
	metricsPanel: {
		display: "grid",
		gap: theme.spacing(1.25),
		padding: theme.spacing(2),
		border: "1px solid color-mix(in srgb, var(--atl-border-strong) 46%, var(--home-frost-border))",
		borderRadius: 24,
		background:
			"linear-gradient(145deg, var(--home-frost-strong) 0%, var(--home-frost-mid) 48%, var(--home-frost-soft) 100%), linear-gradient(180deg, color-mix(in srgb, var(--atl-surface-strong) 42%, transparent) 0%, color-mix(in srgb, var(--atl-surface) 26%, transparent) 100%)",
		boxShadow: "var(--atl-shadow), inset 0 1px 0 var(--home-frost-inset), inset 0 -1px 0 var(--home-frost-inset-soft)",
	},
	metric: {
		display: "grid",
		gridTemplateColumns: "44px minmax(0, 1fr)",
		gap: theme.spacing(1.25),
		alignItems: "center",
		minHeight: 72,
		padding: theme.spacing(1.25),
		border: "1px solid color-mix(in srgb, var(--atl-border) 58%, var(--home-frost-border-soft))",
		borderRadius: 18,
		background:
			"linear-gradient(145deg, color-mix(in srgb, var(--home-frost-strong) 78%, transparent), var(--home-frost-soft)), color-mix(in srgb, var(--atl-surface-muted) 38%, transparent)",
		boxShadow: "inset 0 1px 0 color-mix(in srgb, var(--home-frost-inset) 74%, transparent)",
	},
	metricIcon: {
		display: "grid",
		placeItems: "center",
		width: 44,
		height: 44,
		borderRadius: 14,
		color: "#fff",
		background: "linear-gradient(135deg, var(--metric-color) 0%, var(--metric-color-2) 100%)",
	},
	metricLabel: {
		color: "var(--atl-text-muted)",
		fontSize: 12,
		fontWeight: 900,
		textTransform: "uppercase",
	},
	metricValue: {
		color: "var(--atl-text)",
		fontSize: 22,
		fontWeight: 900,
		lineHeight: 1,
	},
	card: {
		width: "100%",
		height: "100%",
		boxSizing: "border-box",
		padding: theme.spacing(2),
		border: "1px solid color-mix(in srgb, var(--atl-border-strong) 48%, var(--home-frost-border))",
		borderRadius: 22,
		background:
			"linear-gradient(145deg, var(--home-frost-strong) 0%, var(--home-frost-mid) 45%, var(--home-frost-soft) 100%), linear-gradient(180deg, color-mix(in srgb, var(--atl-surface-strong) 40%, transparent) 0%, color-mix(in srgb, var(--atl-surface) 24%, transparent) 100%)",
		boxShadow: "var(--atl-shadow), inset 0 1px 0 var(--home-frost-inset), inset 0 -1px 0 var(--home-frost-inset-soft)",
	},
	allActionsCard: {
		minHeight: 0,
	},
	cardHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		marginBottom: theme.spacing(1.5),
		minWidth: 0,
		"& > div": {
			minWidth: 0,
		},
		[theme.breakpoints.down('sm')]: {
			alignItems: "stretch",
			flexDirection: "column",
			gap: theme.spacing(1.25),
		},
	},
	actionsDashboardButton: {
		flex: "0 0 auto",
		alignSelf: "flex-start",
		minWidth: "0 !important",
		whiteSpace: "nowrap",
		borderRadius: "999px !important",
		paddingLeft: `${theme.spacing(1.25)} !important`,
		paddingRight: `${theme.spacing(1.45)} !important`,
		"& .MuiButton-startIcon": {
			marginRight: theme.spacing(0.65),
			marginLeft: 0,
		},
		[theme.breakpoints.down('sm')]: {
			alignSelf: "stretch",
			justifyContent: "center",
			width: "100%",
		},
	},
	cardTitle: {
		color: "var(--atl-text)",
		fontSize: 20,
		fontWeight: 900,
		lineHeight: 1.15,
	},
	cardSubtitle: {
		marginTop: 4,
		color: "var(--atl-text-soft)",
		fontSize: 13,
		fontWeight: 700,
		lineHeight: 1.35,
	},
	actionGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		gap: theme.spacing(1.25),
		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		},
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: "1fr",
		},
	},
	allActionsGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(4, minmax(250px, 1fr))",
		gap: theme.spacing(1.25),
		[theme.breakpoints.down('lg')]: {
			gridTemplateColumns: "repeat(3, minmax(230px, 1fr))",
		},
		[theme.breakpoints.down('md')]: {
			gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		},
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: "1fr",
		},
	},
	actionTile: {
		position: "relative",
		display: "grid",
		gridTemplateColumns: "46px minmax(0, 1fr)",
		gap: theme.spacing(1.25),
		alignItems: "center",
		minHeight: 116,
		padding: theme.spacing(1.5),
		border: "1px solid var(--atl-border)",
		borderRadius: 18,
		color: "var(--atl-text)",
		background:
			"linear-gradient(145deg, color-mix(in srgb, var(--home-frost-strong) 66%, transparent), var(--home-frost-soft)), color-mix(in srgb, var(--atl-surface-muted) 34%, transparent)",
		boxShadow: "inset 0 1px 0 color-mix(in srgb, var(--home-frost-inset) 62%, transparent)",
		overflow: "hidden",
		cursor: "pointer",
		transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background-color 0.18s ease",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			opacity: 0,
			background:
				"linear-gradient(135deg, color-mix(in srgb, var(--action-color) 22%, transparent) 0%, color-mix(in srgb, var(--action-color-2) 16%, transparent) 58%, transparent 100%)",
			transition: "opacity 0.18s ease",
			pointerEvents: "none",
		},
		"&:hover": {
			transform: "translateY(-2px)",
			borderColor: "color-mix(in srgb, var(--action-color) 36%, var(--atl-border))",
			boxShadow: "var(--atl-shadow-strong)",
			background:
				"linear-gradient(135deg, color-mix(in srgb, var(--action-color) 15%, var(--atl-surface-strong)) 0%, color-mix(in srgb, var(--action-color-2) 13%, var(--atl-surface-muted)) 100%)",
			"&:before": {
				opacity: 1,
			},
		},
	},
	actionIcon: {
		position: "relative",
		zIndex: 1,
		display: "grid",
		placeItems: "center",
		width: 46,
		height: 46,
		borderRadius: 14,
		color: "#fff",
		background: "linear-gradient(135deg, var(--action-color) 0%, var(--action-color-2) 100%)",
		boxShadow: "0 8px 18px color-mix(in srgb, var(--action-color) 25%, transparent)",
		"& svg": {
			width: 24,
			height: 24,
		},
	},
	actionTileContent: {
		position: "relative",
		zIndex: 1,
		minWidth: 0,
	},
	actionTileTitleRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(1),
		minWidth: 0,
	},
	actionName: {
		position: "relative",
		zIndex: 1,
		color: "var(--atl-text)",
		fontSize: 15,
		fontWeight: 900,
		lineHeight: 1.15,
		minWidth: 0,
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	actionDescription: {
		position: "relative",
		zIndex: 1,
		marginTop: 5,
		color: "var(--atl-text-soft)",
		fontSize: 12,
		fontWeight: 650,
		lineHeight: 1.35,
	},
	actionStatusPill: {
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		flex: "0 0 auto",
		padding: theme.spacing(0.35, 0.7),
		borderRadius: 999,
		color: "var(--atl-text-soft)",
		background: "color-mix(in srgb, var(--atl-surface-solid) 66%, transparent)",
		border: "1px solid var(--atl-border)",
		fontSize: 11,
		fontWeight: 850,
		lineHeight: 1,
		"& .MuiSvgIcon-root": {
			fontSize: 14,
		},
		[theme.breakpoints.down('sm')]: {
			display: "none",
		},
	},
	actionTileLocked: {
		"& $actionIcon": {
			filter: "saturate(0.72)",
		},
		"&:not(:hover)": {
			borderColor: "color-mix(in srgb, var(--atl-border) 78%, var(--atl-text-soft))",
			background:
				"linear-gradient(145deg, color-mix(in srgb, var(--home-frost-strong) 55%, transparent), var(--home-frost-soft)), color-mix(in srgb, var(--atl-surface-muted) 30%, transparent)",
		},
	},
	infoPanel: {
		display: "grid",
		gap: theme.spacing(1),
	},
	statusBox: {
		display: "grid",
		gridTemplateColumns: "42px minmax(0, 1fr)",
		gap: theme.spacing(1.25),
		alignItems: "center",
		padding: theme.spacing(1.5),
		border: "1px solid color-mix(in srgb, var(--atl-cyan) 28%, var(--atl-border))",
		borderRadius: 18,
		background:
			"linear-gradient(145deg, color-mix(in srgb, var(--home-frost-strong) 66%, transparent), var(--home-frost-soft)), color-mix(in srgb, var(--atl-cyan) 12%, color-mix(in srgb, var(--atl-surface-muted) 34%, transparent))",
		boxShadow: "inset 0 1px 0 color-mix(in srgb, var(--home-frost-inset) 62%, transparent)",
	},
	profileBlock: {
		display: "grid",
		gridTemplateColumns: "76px minmax(0, 1fr)",
		gap: theme.spacing(1.5),
		alignItems: "center",
		padding: theme.spacing(1.5),
		borderRadius: 18,
		background:
			"linear-gradient(145deg, color-mix(in srgb, var(--home-frost-strong) 66%, transparent), var(--home-frost-soft)), color-mix(in srgb, var(--atl-surface-muted) 34%, transparent)",
		border: "1px solid var(--atl-border)",
		boxShadow: "inset 0 1px 0 color-mix(in srgb, var(--home-frost-inset) 62%, transparent)",
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: "1fr",
			justifyItems: "center",
			textAlign: "center",
		},
	},
	profileAvatar: {
		width: 76,
		height: 76,
		background: "transparent",
	},
	roleStack: {
		display: "flex",
		flexWrap: "wrap",
		gap: 6,
		marginTop: theme.spacing(1),
	},
	eventList: {
		display: "grid",
		gap: theme.spacing(1),
	},
	eventItem: {
		display: "grid",
		gridTemplateColumns: "64px minmax(0, 1fr)",
		gap: theme.spacing(1.25),
		alignItems: "center",
		padding: theme.spacing(1.25),
		border: "1px solid var(--atl-border)",
		borderRadius: 16,
		background:
			"linear-gradient(145deg, color-mix(in srgb, var(--home-frost-strong) 62%, transparent), var(--home-frost-soft)), color-mix(in srgb, var(--atl-surface-muted) 34%, transparent)",
		boxShadow: "inset 0 1px 0 color-mix(in srgb, var(--home-frost-inset) 58%, transparent)",
	},
	eventTime: {
		display: "grid",
		placeItems: "center",
		minHeight: 48,
		borderRadius: 14,
		color: "var(--event-color)",
		background: "color-mix(in srgb, var(--event-color) 12%, var(--atl-surface-strong))",
		fontWeight: 900,
	},
	eventTitle: {
		color: "var(--atl-text)",
		fontSize: 14,
		fontWeight: 900,
	},
	eventSubtitle: {
		color: "var(--atl-text-soft)",
		fontSize: 12,
		fontWeight: 650,
	},
	cardFooter: {
		display: "flex",
		justifyContent: "flex-end",
		gap: theme.spacing(1),
		marginTop: theme.spacing(2),
	},
}));
